declare var propertyTransferBaseUrl: string;

/**
 * Component free information about screen links in the application
 */

import { createHashHistory } from 'history';
import { config } from './config/config';
import { trackLinkClick } from './ap/omniture/omnitureService';

export const hashHistory = createHashHistory();

/**
 * Use member functions to get some link
 */
export const route = {
  /** General */
  styleguide: () => 'styleguide',

  /** App */
  welcome: () => 'welcome',
  dash: () => 'dash',
  cancel: () => 'cancel',

  /**
   * Verification workflow
   */
  registerNew: () => 'registerNew',
  registerFromPortal: () => 'registerFromPortal',
  registerEdit: () => 'registerEdit',
  registerVerify: () => `registerVerify`,
  /** The electronic workflow */
  voi: () => 'voi',
  /** The document sigthing */
  documentSighting: () => 'documentSighting',
  payment: () => `payment`,
  paymentDeleteCard: () => `paymentDeleteCard`,

  /** Errors */
  error: () => 'error',

  /** Outage */
  outage: () => 'outage',
}

/** Directly takes the user to the route  */
export function navigateTo(route: string, replace = false, interactionCat = null, interactionDesc = null ) {
  if (replace) {
    hashHistory.replace(route);
  }
  else {
    hashHistory.push(route);
  }
  if (interactionCat!=null && interactionDesc!=null) {
    trackLinkClick(interactionCat, interactionDesc);
  }
}

/** Directly takes the user to the link  */
export function navigateToError(error) {
  if(error.response && error.response.status == 503) {
    hashHistory.push(route.outage());
  } else {
    hashHistory.push(route.error());
  }
}

/** For use with anchor tags */
export function linkTo(link: string) {
  return propertyTransferBaseUrl + `/#/${link}`;
}

/**
 * For docs we don't need any special router setup and so they are seperate
 * Warning: Don't use `linkTo` or `navigateTo` for these. Use directly in Achors with target `_blank`
 */
export const docs = {
  termsAndConditions: () => `https://auspost.com.au/terms-conditions#property-voi`,
  privacyPolicy: () => `https://auspost.com.au/privacy.html`,
  categoriesAndOptions: () => propertyTransferBaseUrl + `/docs/categoriesAndOptions.pdf`,
  help: () => config.portalConfig.portalHelp,
  reportGuide: () => config.portalConfig.portalReportGuide
}

export function redirectTo(link: string) {
  return `https://ltdia.com.au/VOI/?fbguid=`+link;
}

export function redirectToRegistration() {
  return `https://auspost.com.au/forms/land-title.html`;
}
